import { DevelopmentHistoryDTO } from "../domain/models/dto/DevelopmentHistoryDTO";
import { IDevelopmentHistory } from "../domain/models/DevelopmentHistory";
import { DevelopmentHistoryModel } from "../models/DevelopmentHistoryModel";
import { FileMapper } from "./FileMapper";
import { DevelopmentHistoryTranslationMapper } from "./DevelopmentHistoryTranslationMapper";
import { SimpleMapper } from "./SimpleMapper";

export class DevelopmentHistoryMapper extends SimpleMapper<IDevelopmentHistory, DevelopmentHistoryDTO> {
    protected toDTOFields: string[] = ["id", "files", "translations"];
    protected fromDTOFields: string[] = [
        ...this.toDTOFields,
        "availableLangs",
        "creatorId",
        "createdAt",
        "updatedAt",
    ];
    protected entityConstructor = DevelopmentHistoryModel;
    private fileMapper = new FileMapper();
    private developmentHistoryTranslationMapper = new DevelopmentHistoryTranslationMapper();

    toDTO(model: IDevelopmentHistory): DevelopmentHistoryDTO {
        if (!model) {
            return null;
        }

        const baseDto = super.toDTO(model);

        baseDto.translations =
            model.translations?.map((t) =>
                this.developmentHistoryTranslationMapper.toDTO(t)
            ) ?? [];

        baseDto.files =
            model.files?.map((file) => this.fileMapper.toDTO(file)) ?? [];

        return baseDto;
    }

    fromDTO(dto: DevelopmentHistoryDTO): IDevelopmentHistory {
        if (!dto) {
            return null;
        }
        const baseModel = super.fromDTO(dto);

        baseModel.translations =
            dto.translations?.map((t) =>
                this.developmentHistoryTranslationMapper.fromDTO(t)
            ) ?? [];

        baseModel.files =
            dto.files?.map((file) => this.fileMapper.fromDTO(file)) ?? [];
        return baseModel;
    }
}
